const ChecklistPanel = ({ idKey, data, checkedTitles, toggleExpanded, setCheckedTitle, expanded }) => {
  const title = data?.title || ''
  const conditions = data?.conditions || data?.items || []

  return (
    <div
      style={{
        borderRadius: '0.375rem',
        marginBottom: '0.625rem',
        padding: '0.625rem',
        backgroundColor: checkedTitles[idKey] ? '#beffd0' : '#e9eefb',
        boxShadow: 'rgba(0, 0, 17, 0.24) 0rem 0.0625rem 0.1875rem',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
        <button
          onClick={e => {
            e.stopPropagation()
            toggleExpanded(idKey)
          }}
          aria-expanded={!!expanded[idKey]}
          style={{ background: 'transparent', border: 'none', cursor: 'pointer' }}
        >
          {expanded[idKey] ? '-' : '+'}
        </button>
        <div onClick={() => toggleExpanded(idKey)} style={{ flex: 1, fontWeight: 600 }}>
          {title}
        </div>
        <input
          type='checkbox'
          checked={!!checkedTitles[idKey]}
          onChange={e => setCheckedTitle(idKey, e.target.checked)}
          onClick={e => e.stopPropagation()}
          aria-label={`${idKey}-checklist-confirmation`}
          style={{ marginRight: '0.5rem', color: '#e9eefb' }}
        />
      </div>
      {expanded[idKey] && (
        <ul style={{ marginTop: '0.5rem', paddingLeft: '1.125rem', backgroundColor: 'rgba(255, 255, 255, 0.8)', borderRadius: '0.375rem', padding: '0.625rem 0.625rem 0.625rem 1.75rem' }}>
          {Array.isArray(conditions) && conditions.length > 0
            ? conditions.map((c, i) => (
              <li key={i} style={{ marginBottom: '0.375rem' }} dangerouslySetInnerHTML={{ __html: c }} />
            ))
            : null}
        </ul>
      )}
    </div>
  )
}

export default ChecklistPanel
